<style scoped>
.small-label-checkbox {
  margin-top: 0px !important;
  margin-bottom: 0px !important;
}

.black--text >>> label {
  color: black;
}
</style>

<template>
  <anchor-checkbox
    @change="val => $emit('input', val)"
    :value="value"
    :label="label"
    :disabled="disabled"
    class="pt-0 small-label-checkbox subtitle-1"
    :class="{ 'black--text': !disabled }"
  />
</template>

<script>
export default {
  name: 'AnchorCardTitleCheckbox',
  props: {
    disabled: Boolean,
    label: String,
    value: Boolean,
  },
};
</script>
